export default "__VITE_ASSET__XNOP6ZKA__"